// removed by extract-text-webpack-plugin
module.exports = {"refund-counting-box":"app-components-receipt-transactions-CountingBox-__RefundCountingBox___3v92J"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/CountingBox/RefundCountingBox.css
// module id = 2021
// module chunks = 0